import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState("working");
  const [err, setErr] = useState("");

  useEffect(() => {
    const token = params.get("token") || "";
    if (token.length < 8) { setErr("This unsubscribe link is invalid. Please use the link from your email."); setState("error"); return; }
    api.post("/newsletter/unsubscribe", { token })
      .then(() => setState("done"))
      .catch((e) => { setErr(errMsg(e)); setState("error"); });
  }, [params]);

  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="unsubscribe-page">
      <h1 className="font-serif text-4xl font-bold">
        {state === "working" ? "Unsubscribing…" : state === "done" ? "You've been unsubscribed" : "Something went wrong"}
      </h1>
      <p className="mt-4 text-slate-600" data-testid="unsubscribe-status">
        {state === "done" ? "You won't receive any more newsletters from Albion Pantry. Order emails still arrive as normal." : err}
      </p>
      <Link to="/" className="mt-8 inline-block underline">Back to the shop</Link>
    </div>
  );
}
